import axios from 'axios'
import cookies from 'js-cookie'
import { Message } from 'element-ui'
import JSONBIG from 'json-bigint'


axios.defaults.transformResponse = [function(data) {
  const json = JSONBIG({storeAsString: true})
  const res = json.parse(data)
  return res
}]

//创建一个axios对象
const service = axios.create({
    baseURL: '/api2',//生产环境
    // baseURL: '/api',//测试环境
    timeout: (1000 * 30),
})


//请求拦截
service.interceptors.request.use(
    (config) => {
        // console.log('请求拦截赋值：', config)
        let token = cookies.get('token')
        if (token) config.headers['Authorization'] = token
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

//响应拦截
service.interceptors.response.use(
    (res) => {
        let resData = res.data
        if (res.data.code === 200) {
            return resData
        } else {
            if (resData.msg) Message.error(resData.msg)
            return resData
        }
    },
    (error) => {
        console.log('网络请求响应异常结果：', error)
        if (error.response.data) {
            // Message.error(error.response.data.errors[0].defaultMessage)
            return Promise.reject(error.response.data)
        }else{
            return Promise.reject(error)
        }
    }
)

export default service